const logos = {
    "ib": "https://www.interactivebrokers.com/images/common/logos/ibkr/ibkr-symbol.svg",
    "ig": "https://upload.wikimedia.org/wikipedia/commons/2/2d/IG_Group_logo.svg",
    "okx": "https://upload.wikimedia.org/wikipedia/commons/e/e4/OKX_Logo.svg",
    "virtual": "https://www.interactivebrokers.com/images/common/logos/ibkr/ibkr-symbol.svg"
}

export default logos;